import { MakeMangedRequestOptions } from '~/networking/client';
import { httpRequest, Response } from '~/networking/utils';
import { TransferFundsPayload } from '../../responses/payments/PostTransferFunds';

export const postTransferFunds = ({ getHeaders, getRequestUrl, getUserId }: MakeMangedRequestOptions) => {
    return async (payload: TransferFundsPayload): Promise<Response<unknown>> => {
        const headers = getHeaders(true);
        const httpRequestUrl = getRequestUrl(`/v1/transfers/${getUserId()}`);

        return httpRequest.post(httpRequestUrl, {
            headers,
            body: payload
        });
    };
};
